<script>
    import { Bar } from 'vue-chartjs'
    const axios = require('axios');

    export default {
        name: "AllHoursChart",
        extends: Bar,
        created: function() {  
        },
        data(){
            return{
                chartdata: {
                    labels: [],
                    datasets: /*Ensemble des données du diagramme*/ [
                        {
                            label: 'nombre d\'heures passé sur le projet',
                            backgroundColor: 'rgba(255, 159, 64, 0.3)',
                            borderColor: 'rgb(255, 159, 64)',
                            borderWidth: 1,
                            data: []
                        },
                    ],
                },
                options: /* Object contenant les options du diagramme */ {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                display: true
                            }
                        }]
                    }
                },
                currentMonth: new Date().getMonth()+1,
                currentYear: new Date().getFullYear(),
                userId:0,
            }
        },
        mounted(){    
            this.userId = Number(localStorage.id);
            this.getData();
        },
        methods: {
            getData: function(){

                // Réccuperation des temps rentrés pour la mois courrant
                axios.get(this.$store.state.apiUrl + "time/monthly/" + this.userId + "/" + this.currentYear + "/" + this.currentMonth, {
                    params: {
                        login: localStorage.login,
                        password: localStorage.pass
                    }
                })
                .then(response => {
                    var tmp = Object.values(response.data);

                    // Vérification de la présence du projet dans les labels + mise à jour des informations en conséquence
                    for(var i = 0; i < tmp.length; i++){
                        var index = this.chartdata.labels.indexOf(tmp[i].project_name);
                        var durationLog = tmp[i].duration.split(':');
                        var duree = parseInt(durationLog[0]) + parseInt(durationLog[1])/60

                        if(index == -1){
                            this.chartdata.labels.push(tmp[i].project_name);
                            this.chartdata.datasets[0].data.push(duree);
                        }else{
                            this.chartdata.datasets[0].data[index] += duree;
                        }
                    }

                    this.renderChart(this.chartdata,this.options);
                })
            },
            resetData: function(){
                this.chartdata.labels = [];
                this.chartdata.datasets[0].data = [];
            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: "bottom-center",
                    theme: "outline"
                })
                .goAway(2000);
            },
            nextMonth: function(){ // Event changement de mois (suivant)
                this.currentMonth ++;

                if(this.currentMonth == 13){
                    this.currentMonth = 1;
                    this.currentYear++;
                }
                this.resetData();
                this.getData();
            },
            previousMonth: function(){ // Event changement de mois (précédent)
                this.currentMonth --;

                if(this.currentMonth == 0){
                    this.currentMonth = 12;
                    this.currentYear--;
                }
                this.resetData();
                this.getData();
            },
            changeUserId: function(user_id){ // Event changement d'utilisateur
                this.userId = user_id;
                this.resetData();
                this.getData();
            }
        },
    }
</script>